import React from "react";
import { useNavigate } from "react-router-dom";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0b0f1a] to-[#111827] text-white flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-5xl bg-[#10172a] p-8 md:p-12 rounded-2xl shadow-2xl border border-[#2f3b6c]">
        {/* Header */}
        <h1 className="text-3xl md:text-4xl font-extrabold text-center text-[#f2a900] mb-4 tracking-wide">
          📜 Terms & Conditions
        </h1>
        <p className="text-gray-400 text-center mb-10 text-sm">
          সর্বশেষ আপডেট: ৩০ অক্টোবর ২০২৫
        </p>

        {/* Content Section */}
        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-[#9b59b6] mb-2">
              ১. সেবার সাধারণ নীতিমালা
            </h2>
            <p>
              আমাদের ওয়েবসাইট ব্যবহার করে আপনি সম্মতি দিচ্ছেন যে, আপনি আমাদের
              শর্তাবলীর সকল বিষয় সম্পূর্ণরূপে বুঝে গ্রহণ করেছেন। SpeedFollowInfo.com
              শুধুমাত্র সোশ্যাল মিডিয়া প্রোমোশন সার্ভিস প্রদান করে। আমরা কোনো ভুয়া
              বা বেআইনি কার্যকলাপকে সমর্থন করি না।
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#9b59b6] mb-2">
              ২. পেমেন্ট ও রিফান্ড
            </h2>
            <ul className="list-disc list-inside space-y-1">
              <li>সমস্ত পেমেন্ট অবশ্যই নির্ধারিত গেটওয়ে বা মোবাইল ব্যাংকিং মাধ্যমে করতে হবে।</li>
              <li>ভুল ট্রান্সেকশনের দায় সম্পূর্ণরূপে ইউজারের।</li>
              <li>
                একবার অর্ডার সম্পন্ন হলে রিফান্ড সাধারণত সম্ভব নয়, তবে বিশেষ ক্ষেত্রে
                অ্যাডমিন রিভিউ করবে।
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#9b59b6] mb-2">
              ৩. ইউজার অ্যাকাউন্ট নিরাপত্তা
            </h2>
            <p>
              ইউজার নিজের অ্যাকাউন্ট ও পাসওয়ার্ডের নিরাপত্তার দায়ে থাকবে। অন্য কেউ
              আপনার অ্যাকাউন্ট ব্যবহার করলে SpeedFollowInfo দায়ী থাকবে না।
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#9b59b6] mb-2">
              ৪. টেকনিক্যাল সমস্যা
            </h2>
            <p>
              কোনো প্রকার টেকনিক্যাল সমস্যা, সার্ভার এরর, বা তৃতীয় পক্ষের API ডাউন
              হলে সাময়িকভাবে সার্ভিস বন্ধ থাকতে পারে। অনুগ্রহ করে ধৈর্য ধরুন, সমস্যা
              দ্রুত সমাধান করা হবে।
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#9b59b6] mb-2">
              ৫. কন্টাক্ট সাপোর্ট
            </h2>
            <p>
              কোনো সমস্যার জন্য আমাদের হোয়াটসঅ্যাপে যোগাযোগ করুন:
              <span className="text-[#f2a900] font-semibold">
                {" "}
                01635-315625
              </span>{" "}
              <br />
              অথবা ইমেইল করুন:{" "}
              <span className="text-[#6c63ff] font-semibold">
                speedfollow144@gmail.com
              </span>
            </p>
          </section>
        </div>

        {/* Footer + Back Button */}
        <div className="text-center mt-10 border-t border-[#2f3b6c] pt-6">
          <p className="text-gray-500 mb-4">
            © 2025 SpeedFollowInfo.com — All Rights Reserved
          </p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-gradient-to-r from-[#6c63ff] to-[#a56eff] px-8 py-2 rounded-full text-white font-semibold shadow-md hover:opacity-90 transition"
          >
            🔙 Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}